import styles from "./TextSpinner.module.scss";

import { Spinner, SpinnerSize } from "../Spinner";
import { cn } from "@/utils/cn";

interface Props {
  text: string;
  size?: SpinnerSize;
  className?: string;
}

const TextSpinner: React.FC<Props> = ({ text, size, className }) => {
  return (
    <div className={cn(styles.container, className)}>
      <Spinner size={size} />
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export { TextSpinner };
